import {Card, Descriptions, message, Modal, Switch, Table} from "antd";
import DescriptionsItem from "antd/es/descriptions/Item";
import TextArea from "antd/es/input/TextArea";
import {useVehicleTypeSelect, VehicleTypeSelect} from "./VehicleTypeSelect";
import {ModelSelect, useModelSelect} from "./ModelSelect";
import {useEffect, useState} from "react";
import {useLoading} from "../../common/api/useLoading";
import {ColumnsType} from "antd/es/table";
import {TableColumn} from "../../common/table/Table";
import {SpareAddBody} from "../service/scoot.interface";
import {addSpareIOT} from "../service/scoot.service";

export function SpareIotAddModal(args: {
  isOpen: boolean,
  onClose: () => void
}) {

  const {setVehicleType, vehicleType} = useVehicleTypeSelect()
  const {modelName, setModelName} = useModelSelect()

  const [input, setInput] = useState("")
  const [lines, setLines] = useState<string[]>([])

  const [values, setValues] = useState<SpareAddBody[]>([])

  useEffect(() => {
    if (vehicleType === "SCOOTER") {
      setModelName("S9")
    }

    if (vehicleType === "BIKE") {
      setModelName("W9")
    }

    if (vehicleType === "MOPED") {
      setModelName("I9")
    }
  }, [vehicleType])

  useEffect(() => {
    setLines(input.split("\n").map(it => it.trim()).filter(it => !!it))
  }, [input])

  useEffect(() => {
    const result: SpareAddBody[] = []

    lines.forEach(it => {
      const line = it
        .replaceAll(",", "\t")
        .replaceAll("  ", " ")
        .replaceAll(" ", "\t")

      const [imei, mac] = line.split("\t")
      // const random = ((Math.random() + 1 - 1) * 100000000).toFixed(0).padEnd(8, "0")
      const uselessMac = ["S11", "S7"].includes(modelName)
      const macExists = uselessMac ? true : mac?.length === 12

      if (!!imei && macExists) {
        result.push({
          imei, mac, modelName,
        })
      }
    })

    setValues(result)
  }, [lines, vehicleType, modelName])

  const {loading, setLoading, setDone} = useLoading()

  async function handleOk() {
    if (!isPreview) {
      message.error("미리보기를 확인해주세요")
      return
    }

    setLoading()
    const fails: string[] = []

    for (const value of values) {
      await addSpareIOT(value)
        .then(increaseProgress)
        .catch(() => {
          fails.push(value.imei)
        })
    }

    setDone()
    setProgress(0)

    if (fails.length > 0) {
      message.error(`${fails.length} 개의 IOT 등록 실패`)
      setInput(fails.join("\n"))
      return
    }

    message.success(`${values.length} 개의 IOT 등록 완료`)
    setInput("")
    args.onClose()
  }

  const [progress, setProgress] = useState(0)

  function increaseProgress() {
    setProgress(prev => prev + 1)
  }

  const placeholder = ["S11", "S7"].includes(modelName) ? "IMEI" : "IMEI MAC"

  const [isPreview, setIsPreview] = useState(false)

  function Preview() {
    const columns: ColumnsType<SpareAddBody> = [
      TableColumn("IMEI", row => row.imei),
      TableColumn("MAC", row => row.mac),
      TableColumn("모델", row => row.modelName),
    ]

    return (
      <Card title={"입력한 기기"} size={"small"}>
        <Table size={"small"} dataSource={values} columns={columns} pagination={{pageSize: 5}}/>
      </Card>
    )
  }

  return (
    <Modal
      open={args.isOpen}
      title={"스페어 IOT 등록하기"}
      onCancel={args.onClose}
      onOk={handleOk}
      okText={"등록하기"}
      cancelText={"취소"}
      confirmLoading={loading}
    >
      <Descriptions
        bordered
        size={"small"}
        column={1}
        labelStyle={{width: 120}}
      >
        <DescriptionsItem label={"기기 종류"}>
          <VehicleTypeSelect value={vehicleType} onChange={setVehicleType}/>
        </DescriptionsItem>
        <DescriptionsItem label={"모델"}>
          <ModelSelect value={modelName} onChange={setModelName} vehicleType={vehicleType}/>
        </DescriptionsItem>
        <DescriptionsItem label={"양식"}>{placeholder}</DescriptionsItem>
        <DescriptionsItem label={"입력 대수"}>{values.length}대</DescriptionsItem>
        <DescriptionsItem label={"미리보기"}><Switch checked={isPreview} onChange={setIsPreview}/></DescriptionsItem>
        {progress > 0 && (
          <DescriptionsItem label={"진행률"}>{progress} / {values.length}</DescriptionsItem>
        )}
      </Descriptions>
      {
        isPreview
          ? (
            <Preview/>
          )
          : (
            <TextArea
              style={{height: 280}}
              placeholder={placeholder}
              value={input}
              onChange={e => setInput(e.target.value)}
            />
          )
      }

    </Modal>
  )
}
